import { Form } from '@sitecore-jss/sitecore-jss-react-forms';
import { getUIStrategy, isFormValid } from './formExtensionHelper';

/**
 * Extend the Sitecore JSS Form to support conditional rendering applied in Sitecore.
 * Currently only supports "Equal" conditions and "Enable" actions
 */
export default class ExtendedForm extends Form {
  getCurrentFieldState(field) {
    const fieldState = super.getCurrentFieldState(field);
    const { form } = this.props;
    const fieldValues = this.collectCurrentFieldValues();
    const fieldAction = getUIStrategy({ field, form, fieldValues });
    const formIsValid = isFormValid(fieldValues);
    const { submitInProgress } = this.state;

    return {
      ...fieldState,
      fieldAction,
      formIsValid,
      submitInProgress,
    };
  }
}
